export const normalize = (str) =>
  // essa função serve para comparar strings, ignora diferenças de acentuação e capitalização
  str
    .normalize('NFD') // remove acentos
    .replace(/\s+/g, ' ') // espaços múltiplos -> único espaço
    .trim();


export const sortDescriptions = (array) => {
  return [...array].sort((a, b) =>
    normalize(a.description).localeCompare(
      normalize(b.description),
      'pt',
      { numeric: true, sensitivity: 'base' }
    )
  );
}